/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";
import { CheckImageUrlService } from "src/app/check-image-url.service";
import { ProductHomeService } from "src/app/features/product-feature/product-home/product-home.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-similar-images",
  templateUrl: "./similar-images.component.html",
  styleUrls: ["./similar-images.component.scss"],
})
export class SimilarImagesComponent implements OnInit {
  @Input() images = [];
  constructor(
    private checkImageUrl: CheckImageUrlService,
    private productHomeService: ProductHomeService,
    private router: Router
  ) {}

  ngOnInit() {
    console.log(this.images);
    if (this.images.length) {
      for (let i = 0; i < this.images.length; i++) {
        this.images[i].images = this.checkImageUrl.verifyImage(
          this.images[i].images
        );
        console.log(this.images[i]);
      }

      console.log(this.images);
    }
  }
  favouriteClicked(id) {
    this.productHomeService.toProductHome.next({
      id: this.images[id].inventoryGroupId,
      source: "favourites",
    });
    this.router.navigateByUrl("/product");
  }
}
